import React from 'react';
import { Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, color, oneOf, record, shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { classNames, isContentfulString, isEnumValid, resolveHSLColor } from '@philips-internal/oswald-ui-utils';
import { InlineImage } from '../inline-image/inline-image.js';
import { Text } from '../text/text.js';
import { IconSwitcherAPI } from './icon-switcher-api.js';
import './icon-switcher.css';
function getIcon(value, icons) {
    return icons.find(icon => icon.value === value);
}
function IconSwitcher(props) {
    const icon = getIcon(props.value, props.icons) ?? props.fallbackIcon;
    if (!icon || !isContentfulString(icon.src)) {
        return null;
    }
    const className = classNames({
        'c-icon-switcher': true,
        'c-icon-switcher--reverse': Boolean(props.reverse),
        [`c-icon-switcher--${props.size}`]: isEnumValid(Size, props.size),
    });
    return (React.createElement("div", { className: className },
        React.createElement(Text, { className: "u-hide@empty", value: icon.label }),
        React.createElement(InlineImage, { className: "c-icon-switcher__icon", src: icon.src, style: { color: resolveHSLColor(icon.color) } })));
}
// Disable sort-keys rule to make it easier to input all icons;
/* eslint-disable sort-keys */
const icon = {
    value: string,
    label: string,
    color: color,
    src: string,
};
/* eslint-enable sort-keys */
IconSwitcher.propTypes = {
    fallbackIcon: shape(icon),
    icons: record(icon),
    reverse: bool,
    size: oneOf([Size.SMALL, Size.MEDIUM, Size.LARGE]),
    value: string,
};
IconSwitcher.defaultProps = {
    icons: [],
    size: Size.SMALL,
};
const awesomeProps = {
    api: IconSwitcherAPI,
    type: ComponentType.DATA_DISPLAY,
};
AwesomeComponent(awesomeProps)(IconSwitcher);
export { IconSwitcher, };
//# sourceMappingURL=icon-switcher.js.map